export default __webpack_public_path__ + "static/media/base_logo.592b9f32.svg";